import { isEqual } from "lodash";

export default function ({ pairs }, indices) {
	return isEqual(pairs.sort((p, q) => p[0] - q[0]), indices.sort((p, q) => p[0] - q[0]))
};